<template>
  <el-cascader
    clearable
    :options="options"
    class="w-full"
    v-bind="$attrs"
    v-on="$listeners"
    :props="{
      value: 'name',
      label: 'name'
    }"
  />
</template>

<script>
import BRCityData from "./BRCityData";

export default {
  props: {
    level: {
      type: Number,
      default: 3
    }
  },
  data() {
    return {
      options: []
    };
  },
  mounted() {
    this.options = BRCityData[this.level];
    const noChildrenNameArr = ["香港特别行政区", "澳门特别行政区", "台湾省"];
    this.options.forEach(item => {
      if (noChildrenNameArr.includes(item.name)) {
        item.children = undefined;
      }
    });
    console.log(this.options);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Address/index.vue